import React, { useEffect, useState } from 'react';
import { styled, useTheme, alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Header from './Header';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import Footer from '../components/Footer';
import {
  Route,
  Routes,
  useNavigate,
  Navigate,
  useLocation,
} from 'react-router-dom';
import { TabContext, TabList, TabPanel, TreeView } from '@mui/lab';
import TreeItem, { treeItemClasses } from '@mui/lab/TreeItem';
import Label from '@mui/icons-material/Label';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import PropTypes from 'prop-types';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import Home from '../pages/Home';
import IncidentManagement from '../pages/IncidentManagement/IncidentManagement';
import logo from '../assets/LOGO PERTAMINA.png';
import { House } from '@mui/icons-material';
import HsseDashboard from '../pages/HsseDashboard/HsseDashboard';
import HsseRegulatory from '../pages/HsseRegulatory/HsseRegulatory';
import Patuh from '../pages/Patuh/Patuh';
import RiskManagement from '../pages/RiskManagement/RiskManagement';
import HsseDocument from '../pages/HsseDocument/HsseDocument';
import IMReviewLokasi from '../pages/IncidentManagement/Reviewer/IMReviewLokasi';
import ReviewLokasi from '../pages/IncidentManagement/Reviewer/ReviewLokasi';
import IMReviewUnit from '../pages/IncidentManagement/Reviewer/IMReviewUnit';
import ReviewUnit from '../pages/IncidentManagement/Reviewer/ReviewUnit';
import IMReviewHsse from '../pages/IncidentManagement/Reviewer/IMReviewHsse';
import ReviewHsse from '../pages/IncidentManagement/Reviewer/ReviewHsse';
import IMReviewVpAsset from '../pages/IncidentManagement/Reviewer/IMReviewVpAsset';
import ReviewVpAsset from '../pages/IncidentManagement/Reviewer/ReviewVpAsset';
import IMApproverEGM from '../pages/IncidentManagement/Approver/IMApproverEGM';
import ApproverEGM from '../pages/IncidentManagement/Approver/ApproverEGM';

import CreateLKP from '../pages/IncidentManagement/CreateLKP';
import LaporanK3dll from '../pages/IncidentManagement/Investigate/LaporanK3dll';
import LaporanTransportasi from '../pages/IncidentManagement/Investigate/LaporanTransportasi';
import LaporanProcessSafety from '../pages/IncidentManagement/Investigate/LaporanProcessSafety';
import { Tab, Tabs } from '@mui/material';

import PhoneIcon from '@mui/icons-material/Phone';
import FavoriteIcon from '@mui/icons-material/Favorite';
import PersonPinIcon from '@mui/icons-material/PersonPin';
import EditLKP from '../pages/IncidentManagement/EditLKP';
import CreateLKPDecision from '../pages/IncidentManagement/CreateLKPDecision';
import LaporanInvestigasi from '../pages/IncidentManagement/LaporanInvestigasi';
import IncidentAlert from '../pages/IncidentManagement/CreateLFE';
import LKPToPDF from './Dashboard/LKPToPDF';
import CreateLFE from '../pages/IncidentManagement/CreateLFE';
import CreateIA from '../pages/IncidentManagement/CreateIA';
import useLoginStatus from '../hooks/useLoginStatus';
import IncimanDashboard from '../pages/IncimanDashboard';
import FleetDashboard from '../pages/FleetDashboard';
import MasterUserAdmin from '../pages/MasterUserAdmin';
import MasterUserPermission from '../pages/MasterUserPermission';
import MasterRegion from '../pages/MasterRegion';
import ApplicationConfig from '../pages/ApplicationConfig';
import CreateActionTracking from '../pages/ActionTracking/Create';
import ActionTracking from '../pages/ActionTracking';
import DetailActionTracking from '../pages/ActionTracking/Detail';

const StyledTreeItemRoot = styled(TreeItem)(({ theme }) => ({
  color: theme.palette.text.secondary,
  [`& .${treeItemClasses.content}`]: {
    color: theme.palette.text.secondary,
    borderTopRightRadius: theme.spacing(2),
    borderBottomRightRadius: theme.spacing(2),
    paddingRight: theme.spacing(1),
    fontWeight: theme.typography.fontWeightMedium,
    '&.Mui-expanded': {
      fontWeight: theme.typography.fontWeightRegular,
    },
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-focused, &.Mui-selected, &.Mui-selected.Mui-focused': {
      backgroundColor: `var(--tree-view-bg-color, ${theme.palette.action.selected})`,
      color: 'var(--tree-view-color)',
    },
    [`& .${treeItemClasses.label}`]: {
      fontWeight: 'inherit',
      color: 'inherit',
    },
  },
  [`& .${treeItemClasses.group}`]: {
    marginLeft: 0,
    [`& .${treeItemClasses.content}`]: {
      paddingLeft: theme.spacing(2),
    },
  },
}));

function StyledTreeItem(props) {
  const {
    bgColor,
    color,
    labelIcon: LabelIcon,
    labelInfo,
    labelText,
    ...other
  } = props;

  return (
    <StyledTreeItemRoot
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', p: 0.5, pr: 0 }}>
          <Box component={LabelIcon} color="inherit" sx={{ mr: 1 }} />
          <Typography
            variant="body2"
            sx={{ fontWeight: 'inherit', flexGrow: 1 }}
          >
            {labelText}
          </Typography>
          <Typography variant="caption" color="inherit">
            {labelInfo}
          </Typography>
        </Box>
      }
      style={{
        '--tree-view-color': color,
        '--tree-view-bg-color': bgColor,
      }}
      {...other}
    />
  );
}

StyledTreeItem.propTypes = {
  bgColor: PropTypes.string,
  color: PropTypes.string,
  labelIcon: PropTypes.elementType.isRequired,
  labelInfo: PropTypes.string,
  labelText: PropTypes.string.isRequired,
};

const drawerWidth = 220;

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(3),
    width: 'auto',
  },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 0),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch',
    },
  },
}));

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 5px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 5px)`,
  },
});

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  paper: { background: 'blue' },
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export default function SideBar() {
  const history = useNavigate();
  const theme = useTheme();
  const { loading, isLoggedIn, saveRedirectLocation } = useLoginStatus();
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [hidemenuuhims, sethidemenuuhims] = useState(false);

  function klikHome() {
    history('/hsse');
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [tabValue, setTabValue] = React.useState('1');

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  useEffect(() => {
    let checkRole = localStorage.getItem('roleName');

    if (checkRole) {
      if (checkRole.replaceAll('"', '') == 'USER_HIMS') {
        sethidemenuuhims(true);
      }
    }

    if (loading || isLoggedIn) return;

    saveRedirectLocation(location.pathname);
    history('/');
  }, [loading, isLoggedIn]);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      <AppBar position="fixed" open={open} style={{ backgroundColor: 'white' }}>
        <Toolbar style={{ backgroundColor: 'white' }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={{
              marginRight: 5,
              color: 'black',
              ...(open && { display: 'none' }),
            }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h5" noWrap component="div" width="100%">
            <Header />
          </Typography>
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        open={open}
        PaperProps={{
          sx: {
            backgroundColor: 'white',
          },
        }}
      >
        {/* Logo */}
        <DrawerHeader>
          <img src={logo} width="150" alt="logo" />

          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </DrawerHeader>
        {/* Search */}
        <Divider variant="middle" sx={{ borderColor: '#0F74BC' }} />
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
          />
        </Search>
        <Divider variant="middle" sx={{ borderColor: '#0F74BC' }} />
        {/* Menu */}
        <Box>
          <TabContext value={tabValue}>
            {/* <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={tabValue}
                onChange={handleChangeTab}
                variant="standard"
              >
                <Tab
                  icon={<PhoneIcon />}
                  aria-label="1"
                  value={"1"}
                  style={{ minWidth: "10%" }}
                />
                <Tab
                  icon={<FavoriteIcon />}
                  aria-label="2"
                  value={"2"}
                  style={{ minWidth: "10%" }}
                />
                <Tab
                  icon={<PersonPinIcon />}
                  aria-label="3"
                  value={"3"}
                  style={{ minWidth: "10%" }}
                />
                <Tab
                  icon={<PersonPinIcon />}
                  aria-label="3"
                  value={"4"}
                  style={{ minWidth: "10%" }}
                />
              </Tabs>
            </Box> */}
            <Box sx={{}}>
              <TabPanel value="1" sx={{ padding: '0' }}>
                <TreeView
                  aria-label="gmail"
                  defaultExpanded={['1']}
                  defaultCollapseIcon={<ArrowDropDownIcon />}
                  defaultExpandIcon={<ArrowRightIcon />}
                  defaultEndIcon={<div style={{ width: 24 }} />}
                  sx={{
                    height: '100%',
                    flexGrow: 1,
                    maxWidth: 400,
                    overflowY: 'auto',
                  }}
                >
                  <StyledTreeItem
                    nodeId="1"
                    labelText="Home"
                    labelIcon={House}
                    onClick={klikHome}
                  />
                  {/* <StyledTreeItem
                    nodeId="2"
                    labelText="Leadership"
                    labelIcon={Label}
                  >
                    <StyledTreeItem
                      nodeId="10"
                      labelText="Management Walktrough"
                      labelIcon={LocalOfferIcon}
                      labelInfo=""
                      color="#1a73e8"
                      bgColor="#e8f0fe"
                    />
                    <StyledTreeItem
                      nodeId="11"
                      labelText="HSSE Key Performance Indicator"
                      labelIcon={LocalOfferIcon}
                      labelInfo=""
                      color="#1a73e8"
                      bgColor="#e8f0fe"
                    />
                  </StyledTreeItem> */}
                  {!hidemenuuhims ? (
                    <StyledTreeItem
                      nodeId="2"
                      labelText="Menu Master Data"
                      labelIcon={Label}
                    >
                      <StyledTreeItem
                        nodeId="21"
                        labelText="Region"
                        labelIcon={LocalOfferIcon}
                        labelInfo=""
                        color="#1a73e8"
                        bgColor="#e8f0fe"
                        onClick={() => history('/hsse/master/region')}
                      />
                    </StyledTreeItem>
                  ) : (
                    ''
                  )}
                  {!hidemenuuhims ? (
                    <StyledTreeItem
                      nodeId="3"
                      labelText="Menu Administrator"
                      labelIcon={Label}
                    >
                      {/* <StyledTreeItem
                      nodeId="10"
                      labelText="User Admin"
                      labelIcon={LocalOfferIcon}
                      labelInfo=""
                      color="#1a73e8"
                      bgColor="#e8f0fe"
                      onClick={() => history("/hsse/incident/dashboard")}
                    /> */}
                      <StyledTreeItem
                        nodeId="30"
                        labelText="User Admin"
                        labelIcon={LocalOfferIcon}
                        labelInfo=""
                        color="#1a73e8"
                        bgColor="#e8f0fe"
                        onClick={() => history('/hsse/masteruseradmin')}
                      />

                      <StyledTreeItem
                        nodeId="31"
                        labelText="User Permission"
                        labelIcon={LocalOfferIcon}
                        labelInfo=""
                        color="#1a73e8"
                        bgColor="#e8f0fe"
                        onClick={() => history('/hsse/masteruserpermission')}
                      />
                      <StyledTreeItem
                        nodeId="32"
                        labelText="Application Config"
                        labelIcon={LocalOfferIcon}
                        labelInfo=""
                        color="#1a73e8"
                        bgColor="#e8f0fe"
                        onClick={() => history('/hsse/application/config')}
                      />
                    </StyledTreeItem>
                  ) : (
                    ''
                  )}
                  <StyledTreeItem
                    nodeId="4"
                    labelText="Incident Management"
                    labelIcon={Label}
                  >
                    <StyledTreeItem
                      nodeId="40"
                      labelText="Dashboard LKP"
                      labelIcon={LocalOfferIcon}
                      labelInfo=""
                      color="#1a73e8"
                      bgColor="#e8f0fe"
                      onClick={() => history('/hsse/incident/dashboardlkp')}
                    />
                    <StyledTreeItem
                      nodeId="41"
                      labelText="Dashboard"
                      labelIcon={LocalOfferIcon}
                      labelInfo=""
                      color="#1a73e8"
                      bgColor="#e8f0fe"
                      onClick={() => history('/hsse/incident/dashboard')}
                    />
                    <StyledTreeItem
                      nodeId="42"
                      labelText="Fleet Dashboard"
                      labelIcon={LocalOfferIcon}
                      labelInfo=""
                      color="#1a73e8"
                      bgColor="#e8f0fe"
                      onClick={() => history('/hsse/incident/fleetdashboard')}
                    />
                  </StyledTreeItem>
                  <StyledTreeItem
                    nodeId="5"
                    labelText="Action Tracking"
                    labelIcon={Label}
                  >
                    <StyledTreeItem
                      nodeId="50"
                      labelText="Dashboard"
                      labelIcon={LocalOfferIcon}
                      labelInfo=""
                      color="#1a73e8"
                      bgColor="#e8f0fe"
                      onClick={() => history('/hsse/action-tracking')}
                    />
                  </StyledTreeItem>
                  {/* <StyledTreeItem
                    nodeId="4"
                    labelText="Organization"
                    labelIcon={Label}
                  ></StyledTreeItem> */}
                  <StyledTreeItem
                    nodeId="6"
                    labelText="Risk Management"
                    labelIcon={Label}
                  ></StyledTreeItem>
                  {/* <StyledTreeItem
                    nodeId="6"
                    labelText="Palnning & Procedure"
                    labelIcon={Label}
                  ></StyledTreeItem> */}
                  {/* <StyledTreeItem
                    nodeId="7"
                    labelText="Operation Control"
                    labelIcon={Label}
                  ></StyledTreeItem> */}
                  {/* <StyledTreeItem
                    nodeId="8"
                    labelText="Assurance"
                    labelIcon={Label}
                  ></StyledTreeItem> */}
                  {/* <StyledTreeItem
                    nodeId="9"
                    labelText="Review"
                    labelIcon={Label}
                  ></StyledTreeItem> */}
                </TreeView>
              </TabPanel>
              <TabPanel value="2" sx={{}}>
                2
              </TabPanel>
              <TabPanel value="3" sx={{}}>
                3
              </TabPanel>
            </Box>
          </TabContext>
        </Box>

        {/* <TreeView
          aria-label="gmail"
          defaultExpanded={["1"]}
          defaultCollapseIcon={<ArrowDropDownIcon />}
          defaultExpandIcon={<ArrowRightIcon />}
          defaultEndIcon={<div style={{ width: 24 }} />}
          sx={{ height: 264, flexGrow: 1, maxWidth: 400, overflowY: "auto" }}
        >
          <StyledTreeItem
            nodeId="1"
            labelText="Home"
            labelIcon={House}
            onClick={klikHome}
          />
          <StyledTreeItem nodeId="2" labelText="Leadership" labelIcon={Label}>
            <StyledTreeItem
              nodeId="10"
              labelText="Management Walktrough"
              labelIcon={LocalOfferIcon}
              labelInfo=""
              color="#1a73e8"
              bgColor="#e8f0fe"
            />
            <StyledTreeItem
              nodeId="11"
              labelText="HSSE Key Performance Indicator"
              labelIcon={LocalOfferIcon}
              labelInfo=""
              color="#1a73e8"
              bgColor="#e8f0fe"
            />
          </StyledTreeItem>
          <StyledTreeItem
            nodeId="3"
            labelText="Policy & Objectives"
            labelIcon={Label}
          ></StyledTreeItem>
          <StyledTreeItem
            nodeId="4"
            labelText="Organization"
            labelIcon={Label}
          ></StyledTreeItem>
          <StyledTreeItem
            nodeId="5"
            labelText="Risk Management"
            labelIcon={Label}
          ></StyledTreeItem>
          <StyledTreeItem
            nodeId="6"
            labelText="Palnning & Procedure"
            labelIcon={Label}
          ></StyledTreeItem>
          <StyledTreeItem
            nodeId="7"
            labelText="Operation Control"
            labelIcon={Label}
          ></StyledTreeItem>
          <StyledTreeItem
            nodeId="8"
            labelText="Assurance"
            labelIcon={Label}
          ></StyledTreeItem>
          <StyledTreeItem
            nodeId="9"
            labelText="Review"
            labelIcon={Label}
          ></StyledTreeItem>
        </TreeView> */}
      </Drawer>

      {/* Routes */}
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3 }}
        style={{ backgroundColor: '#F4F4FF' }}
      >
        <DrawerHeader />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Home />
              </>
            }
          />
          {!loading && !isLoggedIn ? (
            <Route path="*" element={<Navigate to="/" replace />} />
          ) : (
            <>
              <Route
                path="/incident/dashboardlkp"
                element={
                  <>
                    <IncidentManagement />
                  </>
                }
              />
              <Route
                path="/incident/createlkp"
                element={
                  <>
                    <CreateLKP />
                  </>
                }
              />
              <Route
                path="/incident/:id"
                element={
                  <>
                    <EditLKP />
                  </>
                }
              />
              <Route
                path="/incident/:id"
                element={
                  <>
                    <LKPToPDF />
                  </>
                }
              />
              <Route
                path="/incident/reviewlokasi"
                element={
                  <>
                    <IMReviewLokasi />
                  </>
                }
              />
              <Route
                path="/incident/reviewlokasi/:id"
                element={
                  <>
                    <ReviewLokasi />
                  </>
                }
              />
              <Route
                path="/incident/reviewunit"
                element={
                  <>
                    <IMReviewUnit />
                  </>
                }
              />
              <Route
                path="/incident/reviewunit/:id"
                element={
                  <>
                    <ReviewUnit />
                  </>
                }
              />
              <Route
                path="/incident/reviewhsse"
                element={
                  <>
                    <IMReviewHsse />
                  </>
                }
              />
              <Route
                path="/incident/reviewhsse/:id"
                element={
                  <>
                    <ReviewHsse />
                  </>
                }
              />
              <Route
                path="/incident/reviewvpasset"
                element={
                  <>
                    <IMReviewVpAsset />
                  </>
                }
              />
              <Route
                path="/incident/reviewvpasset/:id"
                element={
                  <>
                    <ReviewVpAsset />
                  </>
                }
              />
              <Route
                path="/incident/approval"
                element={
                  <>
                    <IMApproverEGM />
                  </>
                }
              />
              <Route
                path="/incident/approval/:id"
                element={
                  <>
                    <ApproverEGM />
                  </>
                }
              />
              <Route
                path="/action-tracking"
                element={
                  <>
                    <ActionTracking />
                  </>
                }
              />
              <Route
                path="/action-tracking/create"
                element={
                  <>
                    <CreateActionTracking />
                  </>
                }
              />
              <Route
                path="/action-tracking/:id"
                element={
                  <>
                    <DetailActionTracking />
                  </>
                }
              />
              <Route
                path="/regulatory"
                element={
                  <>
                    <HsseRegulatory />
                  </>
                }
              />
              <Route
                path="/patuh"
                element={
                  <>
                    <Patuh />
                  </>
                }
              />
              <Route
                path="/risk"
                element={
                  <>
                    <RiskManagement />
                  </>
                }
              />
              <Route
                path="/document"
                element={
                  <>
                    <HsseDocument />
                  </>
                }
              />
              <Route
                path="/CreateLKP"
                element={
                  <>
                    <CreateLKP />
                  </>
                }
              />
              <Route
                path="/incident/createLFE"
                element={
                  <>
                    <CreateLFE />
                  </>
                }
              />

              <Route
                path="/incident/createincidentalert"
                element={
                  <>
                    <CreateIA />
                  </>
                }
              />

              <Route
                path="/lkptopdf"
                element={
                  <>
                    <LKPToPDF />
                  </>
                }
              />
              <Route
                path="/create/laporaninvest/k3dll"
                element={
                  <>
                    <LaporanK3dll />
                  </>
                }
              />
              <Route
                path="/create/laporaninvest/transportasi"
                element={
                  <>
                    <LaporanTransportasi />
                  </>
                }
              />
              <Route
                path="/create/laporaninvest/processsafety"
                element={
                  <>
                    <LaporanProcessSafety />
                  </>
                }
              />
              <Route
                path="/incident/lkpdecision/:lkpEncode"
                element={
                  <>
                    <CreateLKPDecision />
                  </>
                }
              />
              <Route
                path="/incident/lapinvestigasi/create/:investigasiEncode"
                element={
                  <>
                    <LaporanInvestigasi />
                  </>
                }
              />
              <Route
                path="/incident/lapinvestigasi/view/:investigasiEncode"
                element={
                  <>
                    <LaporanInvestigasi />
                  </>
                }
              />
              <Route
                path="/incident/dashboard"
                element={
                  <>
                    <IncimanDashboard />
                  </>
                }
              />
              <Route
                path="/incident/fleetdashboard"
                element={
                  <>
                    <FleetDashboard />
                  </>
                }
              />
              <Route
                path="/masteruseradmin"
                element={
                  <>
                    <MasterUserAdmin />
                  </>
                }
              />
              <Route
                path="/masteruserpermission"
                element={
                  <>
                    <MasterUserPermission />
                  </>
                }
              />
              <Route
                nodeid="20"
                path="/master/region"
                element={
                  <>
                    <MasterRegion />
                  </>
                }
              />
              <Route
                path="/application/config"
                element={
                  <>
                    <ApplicationConfig />
                  </>
                }
              />
            </>
          )}
        </Routes>
        <Footer />
      </Box>
    </Box>
  );
}
